module.exports = require('./dist/md-expansion-panel'); 



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-material-expansion-panel/index.js
// module id = pScm
// module chunks = 1